export const SMS_MAILBOX_MESSAGES = 'SMS_MAILBOX_MESSAGES'

export default {
    SMS_MAILBOX_MESSAGES
}
